import gql from "graphql-tag";

export const sendVerificationSecureSms = gql`
        mutation sendVerificationSecureSms($phoneDialCode: String!, $phoneNumber: String!, $userType: Int!, $jwtToken: String!) {
            sendVerificationSecureSms(phoneDialCode: $phoneDialCode, phoneNumber: $phoneNumber, userType: $userType, jwtToken: $jwtToken) {
                status
                errorMessage
                phoneNumber
                phoneDialCode
            }
        }
        `;

export const verifyPhoneNumber = gql`
        mutation verifyPhoneNumber($phoneDialCode: String!, $phoneNumber: String!, $verificationCode: Int!, $userType: Int, $preferredLanguage: String, $deviceId: String) {
          verifyPhoneNumber(phoneDialCode: $phoneDialCode, phoneNumber: $phoneNumber, verificationCode: $verificationCode, userType: $userType, preferredLanguage: $preferredLanguage, deviceId: $deviceId) {
             status
             errorMessage
             result {
                 auth
                 email
                 userId
                 phoneNumber
                 phoneDialCode
                 token
                 expiresIn
             }
         }
        }
        `;